<template>
  <div class="app_box">
    <div class="app_item" v-for="item in appList" :key="item.appKeyID">
      <!-- 左侧的icon -->
      <div class="app_icon">
        <img
          v-if="item.templateType == 'helm'"
          class="helmIcon"
          src="../../assets/images/helmIcon.svg"
          alt=""
        />
        <div
          :style="{
            backgroundImage: `url(${item.logo || appLogoDef})`
          }"
        ></div>
        <img class="logoIcon" :src="item.logo || appLogoDef" />
      </div>
      <!-- 右侧应用描述 -->
      <div class="app_detail">
        <!-- 应用名称 -->
        <div class="app_name">
          <span @click="viewAppDetail(item)">{{ item.name }}</span>
        </div>
        <!-- 版本 -->
        <div class="app_version">
          版本:{{ item.maxVersion }}
        </div>
        <!-- 访问浏览数 -->
        <div class="app_data">
          <!-- 安装量 -->
          <div class="visit">
            <img :src="appVisit" alt="应用访问数" />
            <span>{{ item.showCount }}</span>
          </div>
          <!-- 浏览量 -->
          <div class="install">
            <img :src="appInstall" alt="应用安装数" />
            <span>{{ item.installCount }}</span>
          </div>
        </div>
        <!-- 应用的描述 -->
        <div class="app_desc">
          <p>{{ item.desc }}</p>
        </div>
        <!-- 分割线 -->
        <div class="app_line"></div>
        <!-- 标签 -->
        <div class="tags_box">
          <div
            class="tag_item ovellipsis"
            v-for="(tag, idx) in item.tags"
            :key="idx"
          >
            {{ tag }}
          </div>
        </div>
        <!-- 查看更多 -->
        <div class="more">
          <el-button size="mini" @click="viewAppDetail(item)">
            查看详情
          </el-button>
        </div>
      </div>
      <div class="app_btn">
        <div>
          {{ timmer(item.updateTime) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appInstall from '@/assets/images/app_install.svg';
import appVisit from '@/assets/images/app_visit.svg';
export default {
  name: 'AppCard',
  props: {
    appList: Array,
    appLoading: Boolean,
    viewAppDetail: Function,
    timmer: Function
  },
  data() {
    return {
      appInstall,
      appVisit,
      appLogoDef: require('@/assets/images/app_icon.png')
    };
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.app_box {
  display: flex;
  flex-wrap: wrap;
  min-height: 250px;
  // 一行
  .app_item {
    display: flex;
    position: relative;
    align-items: center;
    width: 100%;
    margin-bottom: 12px;
    background-color: #ffffff;
    border-radius: 5px;
    border: 1px solid #c3c6ce;
    &:hover .app_icon > div {
      transition: 0.3s ease-in;
      filter: blur(60px);
    }
    p {
      margin-bottom: 0px !important;
    }
    // 左侧图标
    .app_icon {
      height: 100%;
      width: 160px;
      margin-right: 24px;
      padding: 0 30px 30px;
      position: relative;
      overflow: hidden;
      .helmIcon {
        position: absolute;
        top: 4%;
        right: 4%;
        z-index: 9;
      }
      .logoIcon {
        padding-top: 60px;
        width: 100px;
        height: 160px;
        box-sizing: border-box;
      }
      div {
        position: absolute;
        height: 100%;
        width: 100px;
        background-size: cover;
        filter: blur(140px);
        background-position: 10% 50%;
        overflow: hidden;
      }
    }
    // 按钮
    .app_btn {
      width: calc(100% - 854px);
      height: 100%;
      > div {
        text-align: right;
        padding-right: 40px;
        padding-top: 30px;
        color: #8d8d8d;
      }
    }
    // 右侧应用描述
    .app_detail {
      padding: 30px 10px 10px;
      // 名称
      .app_name {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 12px;
        span {
          cursor: pointer;
        }
      }
      .app_name > span:hover {
        color: #456fe2 !important;
      }
      // 版本
      .app_version {
        color: rgba(84, 88, 90, 0.7);
        margin-bottom: 12px;
      }
      // 访问数  浏览数
      .app_data {
        display: flex;
        margin-bottom: 12px;
        span {
          color: rgba(84, 88, 90, 0.7);
          font-size: 12px;
        }
        .visit {
          margin-right: 12px;
        }
      }
      // 描述
      .app_desc {
        font-size: 12px;
        color: rgba(84, 88, 90, 0.7);
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 650px;
        p {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }

      .tags_box {
        display: flex;
        flex-wrap: wrap;
        overflow-x: auto;
        height: 32px;
        .tag_item {
          max-width: 80px;
          color: rgba(84, 88, 90, 0.7);
          height: 22px;
          margin: 0 6px 6px 0;
          background: #f2f4f6;
          border: 1px solid #dde1e6;
          border-radius: 3px;
          padding: 0 8px;
          line-height: 20px;
        }
      }
      // 查看更多
      .more {
        position: absolute;
        right: 32px;
        top: 50%;
        transform: translateY(-50%);
        span {
          color: #fff;
        }
        .el-button {
          border: 1px solid #456fe2;
          border-radius: 5px;
          background-color: #456fe2;
        }
      }
    }
    &:hover {
      box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.1);
      border: 1px solid #456fe2;
    }
    .gray_block {
      position: absolute;
      right: 0;
      top: 0;
      width: 15px;
      height: 15px;
      background-color: #d8d8d8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppCard/rowCard.vue